export const SITEURL = 'barcelonabeachvolley.com'
export const SITENAME = 'Barcelona Beach Volley'
export const ACCEPTED_COOKIES_TOKEN = 'ac'
